
//import React from "react";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Slider from "react-slick";
//import "./slick.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SaveTime from "./SaveTime";
import SaveMoney from "./SaveMoney";
import  NewTopPart2 from "./NewTopPart2";
import SaveEnviro from "./SaveEnviro";
import SaveInsurance from "./SaveInsurance";
import AboutPlateWiz from "./AboutPlateWiz";
import PWForVehicleOwner from "./PWForVehicleOwner";
import PWForTowTruck from "./PWForTowTruck";
import PWForCity from "./PWForCity";
import ContactUs from "./ContactUs";
import Typography from "@material-ui/core/Typography";
import SaveTow from "./SaveTow";
import IntroductionPage from "./IntroductionPage";

import Divider from "@material-ui/core/Divider";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import {Link} from "react-router-dom";
import * as MainConstants from "../../utils/MainConstants";
//import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
//import Grid from '@material-ui/core/Grid';
//import PropTypes from 'prop-types';
//import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
//import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//import * as MainConstants from "../../utils/MainConstants";
import ReCAPTCHA from "react-google-recaptcha";
import PrivatePropertyManagement from "./PrivatePropertManagement";


const styles = theme => ({
    main: {
        width: '100%',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        /*marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            //width: 2000,
            marginLeft: 'auto',
            marginRight: 'auto',
        },*/
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        //margin: theme.spacing.unit,
        minWidth:300,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor:"#e2580d",
        fontSize: theme.typography.pxToRem(10),
        color:"black",
    },
    
    /*gridList: {
        width: 400,
        height:400,
    },*/
    dividerColor: {
        //marginTop: theme.spacing.unit * 3,
        color:"#e2580d",
        backgroundColor:"#e2580d",
    },
    dividerColorPurpole: {
        //marginTop: theme.spacing.unit * 3,
        height: '20px',
        color:"#ffffff",
        //backgroundColor:"#760eb3",
    },
    dividerColor1: {
        //marginTop: theme.spacing.unit * 3,
        color:"#ddedbb",
        backgroundColor:"#ddedbb",
    },
    switchColor: {
        //marginTop: theme.spacing.unit * 3,
        color:"#e2580d",
        //backgroundColor:"#ddedbb",
    },
    panelheading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    panelsecondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    typoTopMargin: {
        marginTop:'40',
    },
    lowMargin: {
        marginTop:'10',
    },
    grid1Control: {
        fontSize: 12,
        color: 'red',
    },
    /*formControl2: {
        //margin: theme.spacing.unit,
        width: '50%',
        
    },*/
    formControlLabel: {
        //margin: theme.spacing.unit,
        width: '100%',
        
    },
    /*
	switchBase: {
		color: deepPurple[300],
		'&$checked': {
			color: deepPurple[500],
		},
		'&$checked + $track': {
			backgroundColor: deepPurple[500],
		},
	},
	*/
 
});
/*
function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
    className={className}
    style={{ ...style, display: "block", background: "red" }}
    onClick={onClick}
    />
);
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
    className={className}
    style={{ ...style, display: "block", background: "green" }}
    onClick={onClick}
    />
);
}
*/


class SimpleSlider extends Component {
    
    
    
    
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    
    render() {
        const {classes, updateAPolicenoticePath} = this.props;
        const mysettings = {
            dots: true,
            infinite: true,
            speed: 700,
            slidesToShow: 1,
            slidesToScroll: 1,
            vertical:false,
            arrows:true,
            autoplay:true,
            
            
            //    nextArrow: <SampleNextArrow />,
            //prevArrow: <SamplePrevArrow />
        };
        
        //let tempImageSource = "/static/images/logo3.png";
        let tempImageSource = "/static/images/logo2clearblue.png";
        return (
          <div  style = { {  backgroundColor:"#F2F6F8" ,  marginRight:0, paddingRight:0, paddingTop:10}}>
              {/*<div>*/}
              {/*} <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.3.15/slick.css" />*/}
              {/* <h2> Welcome To PlateWiz&trade;  <img height='40' width='80' src={require('../../images/license2a.png')} /></h2> */}
              <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                  
                  <Typography variant="h5" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#e2580d', fontSize:40}}>
                      <span style = { { textAlign: 'center', alignSelf: 'center' , fontSize:40, color:'black'}}>Welcome To</span> {MainConstants.APPLICATION_NAME}&trade;
                  </Typography>
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingLeft:20 }}>
                      <img height={140} width={140} src={tempImageSource}   style = { { marginTop:5}}/>
                  </div>
              
              </div>
              <Typography variant="h5" component="h5" style = { { textAlign: 'center', alignSelf: 'center'  , color:'black', fontSize:26}}>
                  Save Time, Money and The Environment!
              </Typography>
              
              <Typography variant="h5" component="h2" style = { {  marginTop:20, textAlign: 'center', alignSelf: 'center'  , color:'#e2580d', fontSize:30}}>
                  {/*<Text>How do you feel when your vehicle is being towed for a parking violation? </Text>*/}
                  {/*Ever had that sinking feeling when you realize your car’s being towed for a parking mistake?*/}
                  Ever had your car towed over a simple parking mistake?
              </Typography>
              
              {/* This was the old slider which I removed it }
        <Slider   adaptiveHeight={false}
        variableWidth={false}
        centerPadding={0}
        autoplay
        centerMode
        arrows={true}
        slidesToShow={5}
        slidesToScroll={1}
        swipe
        draggable={true}
        infinite
        {...mysettings}>
        <div>
        <SaveTow></SaveTow>
        </div>
        <div>
         <SaveTime></SaveTime>
        </div>

        <div>
         <SaveMoney></SaveMoney>
        </div>

        <div>
       <SaveEnviro></SaveEnviro>
        </div>

        <div>
         <SaveInsurance></SaveInsurance>
        </div>
        </Slider>  */}
              {/*
                <Slider {...mysettings}>
                    <div>
                            <div style = { {  backgroundImage: 'url(' + require('../../images/IMG_1.JPG') + ')',  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat', height:600 }}>
                                <SaveTime></SaveTime>
                            </div>

                    </div>
                    <div>
                            <div  style = { {  backgroundImage: 'url(' + require('../../images/IMG_1.JPG') + ')',  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat', height:600 }}>
                                <SaveMoney></SaveMoney>
                            </div>

                    </div>
                    <div>
                            <div style = { {  backgroundImage: 'url(' + require('../../images/IMG_1.JPG') + ')',  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat', height: '100%'}}>
                                <SaveEnviro></SaveEnviro>
                            </div>

                    </div>
                    <div>
                            <div style = { {  backgroundImage: 'url(' + require('../../images/IMG_5.JPG') + ')',  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat', height:600 }}>
                                <SaveInsurance></SaveInsurance>
                            </div>

                    </div>
                </Slider>

                */}
              {/*</div>*/}
              {/* Begin I added these 3-4-2022}*/}
              
              {/*<Grid container spacing={2}  style={{flexDirection:"column"}}> */}
              
              {/*<Grid item xs={12} sm={12} lg={12} >
          <SaveTow></SaveTow>
          </Grid>
          <Divider className={classes.dividerColorPurpole}></Divider>*/}
              {/*<Grid item xs={12} sm={12} md={12} lg={12} >
            <NewTopPart></NewTopPart>
          </Grid> */}
              
              
              
              {/*<Divider className={classes.dividerColorPurpole}></Divider> */}
              
              {/*<Grid item xs={12} sm={12} >
          <SaveTime></SaveTime>
          </Grid>
          <Divider className={classes.dividerColorPurpole}></Divider>
          <Grid item xs={12} sm={12} >
          <SaveMoney></SaveMoney>
          </Grid>
          <Divider className={classes.dividerColorPurpole}></Divider>
          <Grid item xs={12} sm={12}  >
          <SaveEnviro></SaveEnviro>
          </Grid>
          <Divider className={classes.dividerColorPurpole}></Divider>
          <Grid item xs={12} sm={12} >
          <SaveInsurance></SaveInsurance>
          </Grid>*/}
              {/*</Grid>*/}
              <Grid container spacing={2}  style={{flexDirection:"column"}}>
                  {/* End of  I added these 3-4-2022}*/}
                  
                  
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div id="introduction">
                          <IntroductionPage></IntroductionPage>
                          <br/>
                      </div>
                      <Divider className={classes.dividerColorPurpole}></Divider>
                  </Grid>
                  {/*}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div id="savetow">
            <SaveTow></SaveTow>
          
          </div>
          <Divider className={classes.dividerColorPurpole}></Divider>
          </Grid>  */}
                  {/*}
        <Grid item xs={12} sm={12} md={12} lg={12}   xl={12}>
          <div id="newtoppart2">
          <NewTopPart2></NewTopPart2>
          </div>
          <Divider className={classes.dividerColorPurpole}></Divider>
          </Grid>*/}
                  <Grid item xs={12} sm={12} md={12} lg={12}  xl={12}>
                      <div id="aboutplatewiz">
                          <PrivatePropertyManagement> </PrivatePropertyManagement>
                      </div>
                      <Divider className={classes.dividerColorPurpole}></Divider>
                  </Grid>
                  
                  <Grid item xs={12} sm={12} md={12} lg={12}  xl={12}>
                      <div id="aboutplatewiz">
                          <AboutPlateWiz> </AboutPlateWiz>
                      </div>
                      <Divider className={classes.dividerColorPurpole}></Divider>
                  </Grid>
                  
                  {/*}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div id="vehicleowner">
            <PWForVehicleOwner  towAgentConfigCall={this.props.towAgentConfig}  vehicleOwnerConfigCall={this.props.vehicleOwnerConfig} > </PWForVehicleOwner>
            </div>
            <Divider className={classes.dividerColorPurpole}></Divider>
          </Grid> */}
                  
                  {/*}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div id="towtruck">
            <PWForTowTruck towAgentConfigCall={this.props.towAgentConfig}  vehicleOwnerConfigCall={this.props.vehicleOwnerConfig} > </PWForTowTruck>
            </div>
          <Divider className={classes.dividerColorPurpole}></Divider>
          </Grid> */}
                  
                  {/*}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
            <div id="city">
            <PWForCity  towAgentConfigCall={this.props.towAgentConfig}  vehicleOwnerConfigCall={this.props.vehicleOwnerConfig}> </PWForCity>
            </div>
            <Divider className={classes.dividerColorPurpole}></Divider>
          </Grid> */}
                  
                  
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                      <div>
                          <ContactUs> </ContactUs>
                      </div>
                  </Grid>
                  
                  {/*} */}
                  {/*  I tried ti put teh above section in grid so it would work on teh mobile app, small screen, but i had other issues.
          <Grid container>
        <Grid item xs={12} sm={12}>
          <Divider className={classes.dividerColorPurpole}></Divider>
         
          <PWForVehicleOwner  towAgentConfigCall={this.props.towAgentConfig}  vehicleOwnerConfigCall={this.props.vehicleOwnerConfig} > </PWForVehicleOwner>
          
          </Grid>
          <Grid item xs={12} sm={12}>
          <Divider className={classes.dividerColorPurpole}></Divider>
          
          <PWForTowTruck towAgentConfigCall={this.props.towAgentConfig}  vehicleOwnerConfigCall={this.props.vehicleOwnerConfig} > </PWForTowTruck>
      
          </Grid>
          <Grid item xs={12} sm={12}>
          <Divider className={classes.dividerColorPurpole}></Divider>
          
          <PWForCity  towAgentConfigCall={this.props.towAgentConfig}  vehicleOwnerConfigCall={this.props.vehicleOwnerConfig}> </PWForCity>
      
          </Grid>
          <Grid item xs={12} sm={12}>
          </Grid>
          <Grid item xs={12} sm={12}>
          </Grid>
          </Grid>
          */}
              </Grid>
          </div>
        );
    }
    
}
SimpleSlider.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleSlider);
//export default SimpleSlider;
